import { APIProvider } from '@vis.gl/react-google-maps';

import { useAppSelector } from '@/redux/hooks';
import { CatalogMapPoint } from '@/redux/modules/auctionsNearMe/catalogsNearMe.types';
import { getGoogleApiKey } from '@/redux/modules/config';
import { GeoArea } from '@/types/GeoArea';

import { AuctionsNearMeAuctionHouseCount } from './components/GoogleMap/AuctionsNearMeAuctionHouseCount';
import { AuctionsNearMeGoogleMap, MapBounds } from './components/GoogleMap/AuctionsNearMeGoogleMap';
import { AuctionsNearMeSearchInput } from './components/SearchInput/AuctionsNearMeSearchInput';

type Props = {
    geoArea: GeoArea;
    isGeocoding: boolean;
    mapBounds: MapBounds;
    mapPoints: CatalogMapPoint[];
    onBoundsChange: (bounds: MapBounds) => void;
    onGoogleMapsReady: () => void;
    onSearchResults: (bounds: MapBounds) => void;
    onUserMapInteraction: () => void;
    parentSearchTerm: string;
    setGeocoderFailed: (failed: boolean) => void;
    setSearchTerm: (term: string) => void;
    totalUniqueHouses: number;
};

export const AuctionsNearMeMapViewNew = ({
    geoArea,
    isGeocoding,
    mapBounds,
    mapPoints,
    onBoundsChange,
    onGoogleMapsReady,
    onSearchResults,
    onUserMapInteraction,
    parentSearchTerm,
    setGeocoderFailed,
    setSearchTerm,
    totalUniqueHouses,
}: Props) => {
    const googleApiKey = useAppSelector(getGoogleApiKey);

    return (
        <>
            <div className="mt-lg mb-xs smMin:mt-0 smMin:mb-sm">
                <AuctionsNearMeAuctionHouseCount count={totalUniqueHouses} />
            </div>
            <APIProvider apiKey={googleApiKey}>
                <AuctionsNearMeSearchInput
                    currentGeoArea={geoArea}
                    onSearchResults={onSearchResults}
                    parentSearchTerm={parentSearchTerm}
                    setGeocoderFailed={setGeocoderFailed}
                    setPageTitleSearchTerm={setSearchTerm}
                />
                <AuctionsNearMeGoogleMap
                    bounds={mapBounds}
                    isGeocoding={isGeocoding}
                    mapPoints={mapPoints}
                    onBoundsChange={onBoundsChange}
                    onLoad={onGoogleMapsReady}
                    onUserInteraction={onUserMapInteraction}
                />
            </APIProvider>
        </>
    );
};
